<div class="template position-relative" [ngClass]="{'selected-template': isSelected, 'first': positionClass === 'first', 'last': positionClass === 'last'}" id="{{template.id}}">
    <button class="d-flex align-items-center justify-content-between w-100 text-start" type="button"
            (click)="select(template)" >
        <span [innerHTML]="template.label | highlight_search: searchTerm"></span> <i class="fa-solid fa-chevron-right ps-3" [ngClass]="{'d-none': isSelected}"></i>
    </button>
</div>
